import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { TransitionProps } from '@mui/material/transitions';
import Slide from '@mui/material/Slide';
import { Box, OutlinedInput } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HelpIcon from '@mui/icons-material/Help';

export interface DefaultDialogInputProps {
    rows?: number;
    value?: string;
}

export interface DefaultDialogProps {
    title: string;
    message: string;
    children?: React.ReactNode;
    open: boolean;
    type?: "question" | "information" | "warning" | "success";
    onYesClick?: (e?: any | undefined) => void;
    onNoClick?: (e?: any | undefined) => void;
    onClose: () => void;
    inputProps?: DefaultDialogInputProps;

}

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function DefaultDialog(props: DefaultDialogProps) {
    const [dialogProps, setDialogdialogProps] = useState<DefaultDialogProps>(props);
    const [value, setValue] = useState<string>(props.inputProps?.value || "");
    const inputRef = React.useRef<HTMLElement>(null);

    useEffect(() => {
        setDialogdialogProps(props);
        setValue(props.inputProps?.value || "");
    }, [props.open]);

    const handleChange = (event: any) => {
        setValue(event.target.value);
    };

    const handleYesClick = () => {
 

        if (dialogProps.onYesClick !== undefined) {
            dialogProps.onYesClick(value);
        }

        dialogProps.onClose();
    };

    const handleEntering = () => {
        if (inputRef.current != null) {
            inputRef.current.focus();
        }
    };

    const handleNoClick = () => {

        if (dialogProps.onNoClick !== undefined) {
            dialogProps.onNoClick(value);
        }
        dialogProps.onClose();
    };

    const getIcon = () => {
        switch (dialogProps.type) {
            case "warning":
                return <WarningIcon sx={{ color: "#ff9800", mr: 1 }} />;
            case "success":
                return <CheckCircleIcon sx={{ color: "#4caf50", mr: 1 }} />;
            case "information":
                return <InfoIcon sx={{ color: "#2196f3", mr: 1 }} />;
            case "question":
            default:
                return <HelpIcon sx={{ color: "#9c27b0", mr: 1 }} />;
        }
    };

    const getTitle = () => {
        if (dialogProps.title === undefined) {
            if (dialogProps.type === "question" || dialogProps.type === undefined) {
                return "Pergunta";
            } else if (dialogProps.type === "information") {
                return "Informação";
            } else if (dialogProps.type === "warning") {
                return "Aviso";
            } else if (dialogProps.type === "success") {
                return "Sucesso";
            }
        }
        return dialogProps.title
    };

    const getButtons = () => {
        if (dialogProps.type === undefined || dialogProps.type === "question") {
            return (
                <React.Fragment>
                    <Button onClick={handleYesClick} variant='contained'>Sim</Button>
                    <Button onClick={handleNoClick} variant='outlined' autoFocus>
                        Não
                    </Button>
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    <Button onClick={handleYesClick}>Ok</Button>
                </React.Fragment>
            );
        }
    };

    return (
        <Dialog
            open={dialogProps.open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            TransitionProps={{ onEntering: handleEntering }}
            sx={{ zIndex: 10000000}}
            TransitionComponent={Transition}
        >
            <DialogTitle id="alert-dialog-title" sx={{ display: 'flex', alignItems: 'center' }}>
                {getIcon()}
                {getTitle()}
            </DialogTitle>
            <DialogContent dividers sx={{ minHeight: "100px",minWidth:"500px" }}>
                <DialogContentText id="alert-dialog-description">
                    {dialogProps.message}
                    {dialogProps !== undefined && dialogProps.inputProps !== undefined && (
                        <React.Fragment>
                            <Box sx={{ mt: 2 }}>
                                <OutlinedInput
                                    ref={inputRef}
                                    multiline={dialogProps.inputProps.rows !== undefined}
                                    value={dialogProps.inputProps.value}
                                    onBlur={handleChange}
                                    onChange={handleChange}
                                    rows={dialogProps.inputProps.rows}
                                    name='input-justification'
                                    fullWidth
                                />
                            </Box>
                        </React.Fragment>
                    )
                    }
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {getButtons()}
            </DialogActions>
        </Dialog>
    );

}

